
// import router from "../../router";
// import axios from "axios";
// import moment from 'moment';
import { MODAL } from '@/enum/global';


const state = () => ({
    isShow: false,
    modalType: '',
    singlePageAlert: false, //雖然共用錯誤碼，有獨立的錯誤視窗警告
    tabCount: 0, //同一個domain 有幾個分業
    isDownload: false, 
    

});

// getters
const getters = {};

// actions
const actions = {
};

// mutations
const mutations = {

    setShowModal(state, data) {
        state.isShow = data;
    },
    setTabCount(state, data) {
        state.tabCount = data;
    },
    setType(state, data) {
        // console.log(data,'XXX')
        state.modalType = data
    },
    setSinglePageAlert(state, data) {
        // console.log(data,'XXX')
        state.singlePageAlert = data
    },
    setIsDownload(state, data) {
        // console.log(data,'XXX')
        state.isDownload = data
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};